<template>
  <ResponsiveModal
    ref="modal"
    :variant="variant"
    :title="title"
    :description="description"
    :withClear="maxSmall"
    :withSearch="true"
    :confirmLabel="$t('components.buttons.save')"
    :showCancel="!maxSmall"
    :disableConfirm="!categoryRef?.isDirty"
    @update:open="(open) => open && categoryRef?.reset()"
    @confirm="categoryRef?.submit()"
    @clear="$emit('update', {})"
  >
    <slot />
    <template #content>
      <div
        class="relative max-h-[60dvh] md:max-h-[360px] flex flex-col grow bg-primary"
      >
        <Categories
          ref="categoryRef"
          :initialState="initialState"
          :buildingIds="buildingIds"
          :query="modal?.query"
          class="p-4 pb-6 md:pt-0 md:px-6"
          @submit="$emit('update', $event)"
        />
      </div>
    </template>
  </ResponsiveModal>
</template>

<script setup>
import { ref } from "vue";
import { Categories } from "@/SharedComponents/Modals/Content";
import { ResponsiveModal } from "@/SharedComponents/ResponsiveModal";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineEmits(["update"]);

const modal = ref(null);
const categoryRef = ref(null);

defineProps({
  variant: { type: String, default: "property" },
  title: { type: String, required: true },
  description: { type: String, required: true },
  initialState: { type: Object, default: () => ({}) },
  buildingIds: { type: Array, required: false },
});
</script>
